export default __webpack_public_path__ + "static/media/resource-hub-hero1.4b63e847.svg";